module.exports = __webpack_public_path__ + "static/pic01-af116ff086228ef2781f6b0f0d285acc.jpg";